import React, { useEffect, useState } from "react";
import { Col, Table, Form, Row, Spinner, Stack } from "react-bootstrap";
import { PunchItemRemarksCell, usePunchRequestRemarks } from "../../components/ItemRemarks";
import { BsQuestionLg } from "react-icons/bs";
import Select from "react-select";
import { toast } from "react-toastify";
import useApproveRight, { APPROVE_DENIED_MESSAGE } from "../../utils/useApproveRight";
import { ErrorMessage, Field, FieldArray, Formik } from "formik";
import {
  getSingleExpensePunchById,
  postApprovePunch,
  getAllPaymentMethod,
} from "../../services/contractorApi";
import { Helmet } from "react-helmet";
import CardComponent from "../../components/CardComponent";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import ConfirmAlert from "../../components/ConfirmAlert";
import ViewExpensePunch from "./ViewExpensePunch";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";
import { PaymentImages } from "./PaymentImages";
import MyInput from "../../components/MyInput";
import { getAllApprovedAssignComplaints } from "../../services/contractorApi";
import { useTranslation } from "react-i18next";
import {
  getAllEndUserBySupervisorId,
  getSupervisorListWithTotalFreeUserByManagerId,
  getAllComplaintIdListMangerWise,
  getAllComplaintIdListOfficeWise,
} from "../../services/contractorApi";
import { getSalesOnRoId } from "../../services/authapi";
import DatePickercomp from "../../components/DatePicker";
import { getAllAreaManager } from "../../services/contractorApi";
import { getTeamsDetailbyuserid } from "../../services/contractorApi";
import {
  getAllOfficeUser,
  getSingleUserById,
} from "../../services/contractorApi";
import { getAllRegionalOffice } from "../../services/contractorApi";
import { formatAmountINR, onlyDecimalKey, handleDecimalPaste } from "../../utils/helper";

const ApproveExpenseRequest = () => {
  const { t } = useTranslation();

  const { user } = useSelector(selectUser);
  const { id } = useParams();
  // each item's earlier remarks (Request / Approve / Transfer of the requests
  // these pending punches drew from), in the row's Remarks cell
  const punchRemarks = usePunchRequestRemarks("fund", { punch: { punchId: id, pending: true } });
  const navigate = useNavigate();
  const location = useLocation();
  const Complain_id = location?.state?.Complain_id;
  const userId = location?.state?.userId;
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") || null;
  // Approve right of this screen (sidebar tree); the API enforces it too.
  const { canApprove } = useApproveRight();
  const [edit, setEdit] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [managerId, setManagerId] = useState({ type: "", id: "" });
  const [allOfficeUser, setAllofficeUser] = useState([]);
  const [allManagers, setAllManagers] = useState([]);
  const [complaintDetails, setComplaintDetails] = useState({});
  const [complaintData, setComplaintData] = useState([]);
  const [complaintId, setComplaintId] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [freeUserData, setFreeUserData] = useState([]);
  const [freeSupervisorData, setFreeSupervisorData] = useState([]);
  const [allManager, setAllManager] = useState([]);
  const [teamsDetails, setTeamsDetails] = useState({});
  const [selectedSAId, setSelectedSAId] = useState(null);
  const [allSa, setAllSa] = useState([]);

  const [allRegionalOffice, setAllRegionalOffice] = useState([]);
  const [allPaymentMethod, setAllPaymentMethod] = useState([]);
  const fetchSingleData = async () => {
    const punchDate = location?.state?.punch_date;
    const res = await getSingleExpensePunchById(
      userId,
      Complain_id,
      false,
      punchDate,
    );
    if (res.status) {
      setEdit(res.data);
    } else {
      setEdit([]);
    }
  };

  const fetchRegionalOfficeList = async () => {
    const res = await getAllRegionalOffice({});
    if (res.status) {
      // setAllRegionalOffice(res.data);
      const options = res.data.map((itm) => ({
        label: itm?.regional_office_name,
        value: itm?.ro_id,


      }))
      setAllRegionalOffice(options);
    } else {
      setAllRegionalOffice([]);
    }
  };
  const fetchAreaManager = async () => {
    const res = await getAllAreaManager();
    if (res.status) {
      console.log(`teamsDetails`, teamsDetails);
      const managers = res.data.filter(
        (manager) => manager.id == teamsDetails?.manager
      );
      console.log(`managers`, managers);
      setAllManager(managers);
    } else {
      setAllManager([]);
    }
  };
  //   submit form
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    if (type !== "view" && !canApprove) {
      toast.error(APPROVE_DENIED_MESSAGE);
      return;
    }
    const items = values.items;
    const refinedPaymentImages = values.payment_images.map((item) => ({
      image: item.image,
      title: item.title,
    }));

    // extract first row's mode & transaction (assuming single mode per entry)
    const firstPaymentMode = values.payment_images[0]?.payment_mode;
    const payment_mode =
      firstPaymentMode && typeof firstPaymentMode === "object"
        ? firstPaymentMode.value
        : firstPaymentMode || "";
    const transaction_id = values.payment_images[0]?.transaction_id || "";

    const modifiedData = items.map((data) => {
      return {
        item_id: data.item_id,
        id: data.id,
        item_qty: data.approved_qty || 0,
        item_price: data.total_price || 0,
        transaction_id: transaction_id,
        payment_mode: payment_mode,
        fund_id: data.fund_id,
        punch_id : data.punch_id,
        // Carried so a rejection (approve quantity 0) reaches the punch row and
        // the person who punched can see why it was turned down.
        reject_remark: data.reject_remark || "",
      };
    });

    const totalApprovedAmount = values?.items?.reduce(
      (total, item) => total + Number(item.total_price || 0),
      0
    );

    let transfer_to = "";
    let category_type = "";

    if (values.end_users_id) {
      transfer_to = values.end_users_id?.value || values.end_users_id;
      category_type = "end_user";
    } else if (values.supervisor_id) {
      transfer_to = values.supervisor_id?.value || values.supervisor_id;
      category_type = "supervisor";
    } else if (values.area_manager_id) {
      transfer_to = values.area_manager_id?.value || values.area_manager_id;
      category_type = "manager";
    } else if (values.office_users_id) {
      transfer_to = values.office_users_id;
      category_type = "office_user";
    }

    const sData = {
      user_id: values.user_id,
      approved_amount: totalApprovedAmount,
      complaint_id: edit?.complaintDetails?.complaint_id,
      items: modifiedData,
      transaction_images: refinedPaymentImages,
      transaction_id: transaction_id,
      payment_mode: payment_mode,
      transfer_to: transfer_to,
      category_type: category_type,
    };

    // return console.log("sData", sData);
    const res = await postApprovePunch(sData);

    if (res.status) {
      toast.success(res.message);
      navigate(-1);
    } else {
      toast.error(res.message);
    }
    resetForm();
    setSubmitting(false);
  };

  const allItems =
    edit?.items?.length > 0
      ? edit.items.map((data) => {
          // Each row opens at the quantity that was actually punched, not at 0.
          // Zero means "reject", and a screen full of zeros made rejection the
          // accidental default: a tranche-split punch arrives as several rows,
          // and any row the approver did not get to was silently thrown away —
          // the user then reported their expense as missing. Approving less is
          // still a deliberate act; the approver types the smaller number.
          //
          // Same arithmetic the quantity field runs on change, so a prefilled
          // row and a hand-typed one are identical.
          const punchedQty = Number(data?.punched_qty || 0);
          const price = Number(data?.item_price || 0);
          const totalAmount = Number(data?.total_Amount || 0);
          const approvedAmt = Number((punchedQty * price).toFixed(2));

          return {
            item_name: data?.item_name,
            item_images: data?.item_images,
            item_id: data?.item_id,
            transfer_date: data?.transfer_date,
            item_price: data?.item_price,
            remaining_approved_qty: data?.item_remaining_qty,
            total_Amount: data?.total_Amount,
            punch_at: edit?.punch_at,
            complaint_id: edit?.complaint_id,
            user_id: edit?.user_id,
            approved_qty: punchedQty,
            total_price: approvedAmt,
            remaining_qty: 0,
            remaining_amount: Number((totalAmount - approvedAmt).toFixed(2)),
            reject_remark: "",
            fund_id: data?.fund_id,
            punched_qty : data?.punched_qty,
            punch_id : data?.punch_id,
            stock_month: data?.stock_month,
            stock_date: data?.stock_date,
          };
        })
      : [];

  const fetchAllocateData = async () => {
    const res = await getAllApprovedAssignComplaints({
      is_dropdown: true,
    });
    setIsLoading(true);
    if (res.status) {
      const options = res.data.map((itm) => ({
        label: itm?.complaint_unique_id,
        value: itm?.id,
        ...itm,
      })); setComplaintId(options);
      setComplaintData(res.data);




    } else {
      setComplaintData([]);
      setComplaintId([]);
    }
    setIsLoading(false);
  };

  // Ask for the one user this screen is about, rather than sifting the whole
  // company list — that list hides soft-deleted users and users another admin
  // created, either of which emptied this field. Same change as the punch
  // screens; the list stays as the fallback.
  const fetchOfficeUser = async () => {
    const res = await getSingleUserById(userId);
    if (res?.status && res?.data?.id) {
      setAllofficeUser([res.data]);
      return;
    }
    const list = await getAllOfficeUser();
    setAllofficeUser(
      list?.status
        ? list.data.filter((officeUser) => officeUser?.id == userId)
        : [],
    );
  };

  const handleManagerChange = async (value) => {
    if (!value) return setFreeSupervisorData([]);
    fetchFreeSupervisorData(value);
  };

  const fetchFreeSupervisorData = async (id) => {
    const res = await getSupervisorListWithTotalFreeUserByManagerId(id);
    if (res.status) {
      const supervisor = res.data.filter(
        (manager) => manager.id == teamsDetails?.supervisor
      );
      setFreeSupervisorData(supervisor);
    } else {
      setFreeSupervisorData([]);
      toast.error(res.message);
    }
  };
  const handleSupervisorChange = async (value, setvalue) => {
    if (setvalue) {
      setvalue(`request_data[${id}].supervisor_id`, value);
      setvalue(`request_data[${id}].end_users_id`, "");
    }
    if (!value) return setFreeUserData([]);
    fetchFreeUsersData(value);
  };

  const fetchPaymentMethodData = async () => {
    const res = await getAllPaymentMethod("", "", "");
    console.log("payment methods response", res);
    if (res?.status) {
      const list = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.data)
        ? res.data.data
        : [];
      const options = list.map((itm) => ({
        label: itm.method || itm.name || itm.payment_method || "",
        value: itm.id,
      }));
      setAllPaymentMethod(options);
    } else {
      setAllPaymentMethod([]);
    }
  };

  useEffect(() => {
    if (id !== "new") {
      fetchOfficeUser();
      fetchAllocateData();
      fetchRegionalOfficeList();

      fetchSingleData();
      fetchAreaManager();
      fetchComplaintData();
      getTeamsDetailsbyuserid(userId);
      fetchPaymentMethodData();
    }
  }, []);

  const fetchFreeUsersData = async (id) => {
    const res = await getAllEndUserBySupervisorId(id);
    if (res.status) {
      const user = res.data.filter(
        (manager) => manager.id == teamsDetails?.team_member
      );
      setFreeUserData(user);
    } else {
      setFreeUserData([]);
      toast.error(res.message);
    }
  };

  const itemFormatOptionLabel = ({ label, unique_id, image }) => (
    <div className="d-flex">
      <img
        src={`${process.env.REACT_APP_API_URL}${image}`}
        className="avatar me-2"
      />
      <span className="small d-grid">
        <span>{label}</span>
        <span className="text-gray">{unique_id}</span>
      </span>
    </div>
  );
  const fetchComplaintData = async () => {
    // 🛑 guard — bina managerId kuch bhi mat chalao
    if (!managerId || !managerId.type || !managerId.id) {
      setComplaintData([]);
      return;
    }

    const res =
      managerId.type === "manager"
        ? await getAllComplaintIdListMangerWise(managerId.id)
        : await getAllComplaintIdListOfficeWise(managerId.id);

    if (res?.status) {
      setComplaintData(res.data);
    } else {
      setComplaintData([]);
    }
  };

  const fetchSaData = async (ro_id) => {
    const res = await getSalesOnRoId(ro_id);
    if (res.status) {

      const options = res.data.map((itm) => ({
            label: itm?.sales_area_name,
                                      value: itm?.id,
      }))
      setAllSa(options);
      // toast.success(res.message);
    } else {
      setAllSa([]);
      toast.error(res.message);
    }
  };

  const getTeamsDetailsbyuserid = async (userid) => {
    const res = await getTeamsDetailbyuserid(userid);
    if (res.status) {
      // setComplaintDetails(res.data[0]);
      setTeamsDetails(res.data[0]);
      // console.log(`teamsDetails`, teamsDetails);
    } else {
      // setComplaintDetails({});
      setTeamsDetails({});
    }
  };

  useEffect(() => {
    fetchAreaManager();
  }, [teamsDetails]);

  // useEffect(() => {

  // }, [teamsDetails]);

  const parseCustomDate = (dateStr) => {
    // "24-11-2025 11:21:53 AM"
    const [datePart, timePart, ampm] = dateStr.split(" ");
    const [day, month, year] = datePart.split("-").map(Number);
    let [hours, minutes, seconds] = timePart.split(":").map(Number);

    // Convert to 24-hour format
    if (ampm === "PM" && hours < 12) hours += 12;
    if (ampm === "AM" && hours === 12) hours = 0;

    return new Date(year, month - 1, day, hours, minutes, seconds);
  };

  return (
    <>
      <Helmet>
        <title>
          {type === "view" ? "View" : "Create"} Expense Punch · CMS Electricals
        </title>
      </Helmet>

      <Col md={12} data-aos={"fade-up"} data-aos-delay={200}>
        <CardComponent
          showCardHeader={true}
          className={type === "view" && "after-bg-light"}
          title={`${type === "view" ? "View" : "Approve"} Expense Punch`}
        >
          <Formik
            enableReinitialize={true}
           initialValues={{
  expense_punch_for: edit?.expense_punch_for || 1,

  end_users_id: edit?.end_users_id || "",
  supervisor_id: edit?.supervisor_id || "",
  office_users_id: "",
  area_manager_id: "",

  items:
    allItems?.length > 0
      ? allItems
      : [
          {
            item_name: "",
            prev_qty: "",
            prev_amount: "",
            qty: "",
            amount: "",
            sub_total: "",
          },
        ],

  user_id: edit?.user_id || "",
  complaint_id: edit?.complaintDetails?.complaint_id || "",

  fund_date: edit?.punch_at
    ? parseCustomDate(edit.punch_at).toISOString().split("T")[0]
    : new Date().toISOString().split("T")[0],

  regional_office: edit?.complaintDetails
    ? {
        label:
          edit?.complaintDetails?.companyDetails
            ?.selectedRegionalOffices?.[0]?.regional_office_name,
        value:
          edit?.complaintDetails?.companyDetails
            ?.selectedRegionalOffices?.[0]?.id,
      }
    : null,

  sales_area_id: edit?.complaintDetails
    ? {
        label:
          edit?.complaintDetails?.companyDetails
            ?.selectedSaleAreas?.[0]?.sales_area_name,
        value:
          edit?.complaintDetails?.companyDetails
            ?.selectedSaleAreas?.[0]?.id,
      }
    : null,

  // 🔥 PAYMENT IMAGES PREFILL (MAIN FIX)
  payment_images:
    edit?.payment_images?.length > 0
      ? edit.payment_images.map((img) => ({
          image: img.image || "",
          title: img.title || "",
          payment_mode: edit?.payment_method_id
            ? {
                label: edit?.payment_method_name || edit?.payment_mode || "",
                value: edit.payment_method_id,
              }
            : "",
          transaction_id: edit?.transaction_id || "",
        }))
      : [
          {
            image: "",
            title: "",
            payment_mode: "",
            transaction_id: "",
          },
        ],
}}

            // validationSchema={addStockPunchSchema}
            onSubmit={handleSubmit}
          >
            {(props) => {
              return (
                <Form onSubmit={props?.handleSubmit}>
                  <Row className="g-3">
                    {type === "view" ? (
                      <ViewExpensePunch edit={edit} />
                    ) : (
                      <>
                        <FieldArray name="items ">
                          {({ remove, push }) => (
                            <div>
                              {/* <span>
                                {" "}
                                User Name :{" "}
                                <span className="fw-bold">
                                  {" "}
                                  {edit[0]?.user_name ?? "--"}
                                </span>
                             s </span>
                              <br />
                              <span>
                                {" "}
                                Complaint No :{" "}
                                <span className="fw-bold">
                                  {" "}
                                  {edit[0]?.complaint_unique_id ?? "--"}
                                </span>
                              </span> */}
                              <Row className="g-3">
                                <Form.Group as={Col} md={3}>
                                  <Form.Label className="small">
                                    {t("Office")}{" "}
                                  </Form.Label>
                                  <Select
                                    placeholder="Office"
                                    menuPortalTarget={document.body}
                                    value={
                                      allOfficeUser && allOfficeUser.length > 0
                                        ? {
                                          label: allOfficeUser[0].name,
                                          value: allOfficeUser[0].id,
                                        }
                                        : null
                                    }
                                    isClearable={true}
                                    name={`office_users_id`}
                                    options={allOfficeUser?.map((user) => ({
                                      label: user.name,
                                      value: user.id,
                                    }))}
                                    isDisabled={
                                      edit?.id ||
                                      props?.values?.area_manager_id ||
                                      props?.values?.supervisor_id ||
                                      props?.values?.end_users_id
                                    }
                                    onChange={(e) => {
                                      if (e == null) {
                                        props.resetForm();
                                        setComplaintDetails({});
                                        return;
                                      }

                                      setManagerId({
                                        type: "office",
                                        id: e?.value,
                                      });
                                      props.setFieldValue(
                                        "office_users_id",
                                        e.value
                                      );
                                      props.setFieldValue(
                                        "area_manager_id",
                                        ""
                                      );
                                      // props.setFieldValue(super, "");
                                      props.setFieldValue("endUserName", "");
                                      fetchAllocateData();

                                      setComplaintDetails({});

                                      // setRequestForName(e?.label);
                                      // fetchUserWalletBalance(e?.value, "office_user");
                                    }}
                                  />
                                </Form.Group>
                                <Form.Group as={Col} md={3}>
                                  <Form.Label className="small">
                                    {t("Manager")}
                                  </Form.Label>
                                  <Select
                                    placeholder={t("Manager")}
                                    menuPortalTarget={document.body}
                                    // value={main?.area_manager_id}=
                                    value={props?.values?.area_manager_id}
                                    name="area_manager_id"
                                    // value={edit?.user_id}
                                    isClearable={true}
                                    options={allManager?.map((user) => ({
                                      label: user.name,
                                      value: user.id,
                                    }))}
                                    isDisabled={
                                      edit?.id || props?.values?.office_users_id
                                    }
                                    onChange={(e) => {
                                      // 🔥 if CLEAR button clicked (e = null)
                                      if (!e || e == null) {
                                        props.resetForm();
                                        setComplaintDetails({});

                                        props.setFieldValue(
                                          "area_manager_id",
                                          null
                                        );
                                        props.setFieldValue(
                                          "supervisor_id",
                                          null
                                        );
                                        props.setFieldValue(
                                          "end_users_id",
                                          null
                                        );
                                        setManagerId(null);
                                        setFreeUserData([]);
                                        return; // stop further code
                                      }

                                      // 🔥 if normal selection
                                      handleManagerChange(e?.value);

                                      fetchComplaintData();

                                      //  fetchFreeSupervisorData(e?.value);

                                      props.setFieldValue("area_manager_id", e);

                                      // props.setFieldValue(
                                      //   "supervisor_id",
                                      //   supervisorId.m
                                      // );
                                      props.setFieldValue("end_users_id", null);

                                      setManagerId({
                                        type: "manager",
                                        id: e?.value,
                                      });

                                      setFreeUserData([]);
                                    }}
                                  />
                                </Form.Group>
                                <Form.Group as={Col} md={3}>
                                  <Form.Label className="small">
                                    {t("Supervisor")}
                                  </Form.Label>
                                  <Select
                                    placeholder={t("Supervisor")}
                                    name={"supervisor_id"}
                                    menuPortalTarget={document.body}
                                    // value={main?.supervisor_id}
                                    value={props?.values?.supervisor_id}
                                    isClearable={true}
                                    options={freeSupervisorData?.map(
                                      (user) => ({
                                        label: user.name,
                                        value: user.id,
                                      })
                                    )}
                                    isDisabled={
                                      edit?.id || props?.values?.office_users_id
                                    }
                                    // name={}
                                    onChange={(e) => {
                                      if (!e || e == null) {
                                        props.setFieldValue(
                                          "supervisor_id",
                                          ""
                                        );
                                        props.setFieldValue("end_users_id", "");
                                        setManagerId(null);
                                        return;
                                      }
                                      handleSupervisorChange(
                                        e?.value,
                                        props.setFieldValue
                                      );

                                      props.setFieldValue("supervisor_id", e);
                                      setManagerId({
                                        type: "manager",
                                        id: e?.value,
                                      });
                                      // setRequestForName(e?.label);
                                      // fetchUserWalletBalance(e?.value, "supervisor_user");
                                    }}
                                  />
                                </Form.Group>

                                <Form.Group as={Col} md={3}>
                                  <Form.Label className="small">
                                    {t("End User")}
                                  </Form.Label>
                                  <Select
                                    placeholder={t("End User")}
                                    name={"end_users_id"}
                                    menuPortalTarget={document.body}
                                    // value={main?.end_users_id}
                                    value={props?.values?.end_users_id}
                                    isClearable={true}
                                    options={freeUserData?.map((user) => ({
                                      label: user.name,
                                      value: user.id,
                                    }))}
                                    isDisabled={
                                      edit?.id || props?.values?.office_users_id
                                    }
                                    // name={endUserName}
                                    onChange={(e) => {
                                      props.setFieldValue("end_users_id", e);
                                      // setRequestForName(e?.label);
                                      setManagerId({
                                        type: "manager",
                                        id: e?.value,
                                      });
                                    }}
                                  />
                                </Form.Group>

                                <Form.Group as={Col} md={3}>
                                  <Form.Label className="small">
                                    {t("Select Complaint")}{" "}
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Select
                                    name="complaint_id"
                                    options={complaintId}
                                    value={
                                      complaintId.find(
                                        (opt) => opt.value === props.values.complaint_id
                                      ) ||
                                      (edit?.complaint_id
                                        ? {
                                            label: edit?.complaint_unique_id,
                                            value: edit?.complaint_id,
                                          }
                                        : null)
                                    }
                                onChange={(e) => {
  if (!e) {
    props.setFieldValue("complaint_id", "");
    props.setFieldValue("regional_office", null);
    props.setFieldValue("sales_area_id", null);
    setSelectedSAId(null);
    setComplaintDetails({});

    return;
  }

  // complaint
  props.setFieldValue("complaint_id", e.value);

  // -------- RO --------
  // Defensive: office-list complaint rows carry no ro_id/sales_area_id JSON —
  // JSON.parse(undefined) threw on select and killed the rest of the prefill.
  const roId = (() => {
    try {
      return !e?.regionalOffice
        ? e?.ro_id
          ? JSON.parse(e.ro_id)[0]
          : null
        : e?.regionalOffice?.[0]?.id;
    } catch (_) {
      return null;
    }
  })();

  const selectedRO = allRegionalOffice.find(
    (ro) => ro.value == roId
  );

  props.setFieldValue("regional_office", selectedRO);

  fetchSaData(roId);

  // -------- SA --------
  const saId = (() => {
    try {
      return !e?.saleAreaDetails
        ? e?.sales_area_id
          ? JSON.parse(e.sales_area_id)[0]
          : null
        : e?.saleAreaDetails?.[0]?.id;
    } catch (_) {
      return null;
    }
  })();

  const selectedSA = allSa.find(
    (sa) => sa.value == saId
  );

  props.setFieldValue("sales_area_id", selectedSA);

  // setComplaintDetails((prev) => ({
  //   ...prev,
  //   ...e,
  // }));
  setComplaintDetails({
  companyDetails: {
    selectedRegionalOffices: e?.regionalOffice || [],
    selectedSaleAreas: e?.saleAreaDetails || [],
    outletDetail: {
      // a complaint without an outlet (other company) has none here
      outlet_unique_id: e?.outlet?.[0]?.outlet_unique_id,
      outlet_name: e?.outlet?.[0]?.outlet_name,
      customer_code: e?.outlet?.[0]?.customer_code,
      outlet_category: e?.outlet?.[0]?.outlet_category,
    },
  },
  complaint_punched_amount: e?.complaint_punched_amount,
});

}}

                                  />

                                  <ErrorMessage
                                    name="complaint_id"
                                    component="small"
                                    className="text-danger"
                                  />
                                </Form.Group>

                                <Form.Group as={Col} md={3}>
                                  <Form.Label className="small">
                                    {t("Regional Office Name")}
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Select
                                    menuPortalTarget={document.body}
                                    name={`regional_office`}
                                  
                                    options={allRegionalOffice}
                                    // value = {props.}
 value={props.values.regional_office} 
                                    isClearable
                                    isDisabled={props?.values?.complaint_id}
                                    onChange={(e) => {

                                      fetchSaData(e?.value);



                                      setManagerId({
                                        type: "office",
                                        id: e?.value,
                                      });
                                      props.setFieldValue(`complaint_id`, "");
                                      props.setFieldValue(`regional_office`, e);

                                    }}
                                  />
                                  <ErrorMessage
                                    name="regional_office"
                                    component="small"
                                    className="text-danger"
                                  />
                                </Form.Group>

                                <Form.Group as={Col} md={3}>
                                  <Form.Label className="small">
                                    {t("Sales Area")}{" "}
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Select
                                    menuPortalTarget={document.body}
                                    value={props?.values?.sales_area_id}
                                   
                                    name={`sales_area_id`}
                                   options = {allSa}
                                    isDisabled={props?.values?.complaint_id}
                                    isClearable
                                    onChange={(e) => {
                                      // fetchComplaintData("4", e?.value);
                                      setManagerId({
                                        type: "manager",
                                        id: e?.value,
                                      });
                                      props.setFieldValue(`complaint_id`, "");
                                      props.setFieldValue(`complaint_id`, "");
                                      props.setFieldValue(`area_manager_id`, e);
                                    }}
                                  />
                                  <ErrorMessage
                                    name="sales_area_id"
                                    component="small"
                                    className="text-danger"
                                  />
                                </Form.Group>

                                <Form.Group as={Col} md={3}>
                                  <Form.Label className="small">
                                    {t("Select Punch Date")}
                                  </Form.Label>
                                  <DatePickercomp
                                    name="fund_date"
                                    value={props?.values?.fund_date}
                                    label={t("Select Punch Date")}
                                    disabled={true}
                                    sendDate={(value) => {
                                      props.setFieldValue("fund_date", value);
                                    }}
                                  />
                                </Form.Group>

                                <div
                                  className="row"
                                  style={{ marginTop: "20px" }}
                                >
                                  <Col md={6}>
                                    <div className="p-20 shadow rounded h-100">
                                      <strong className="text-secondary">
                                        {t("Outlet Details")}
                                      </strong>

                                      <div className="mt-2">
                                        <table className="table-sm table">
                                          <tbody>
                                            <tr>
                                              <th>{t("Regional Office ")} :</th>
                                          <td>
  {complaintDetails
    ?.companyDetails
    ?.selectedRegionalOffices?.[0]
    ?.regional_office_name
  ||
  edit?.complaintDetails
    ?.companyDetails
    ?.selectedRegionalOffices?.[0]
    ?.regional_office_name
  ||
  "-"}
</td>

                                            </tr>

                                            <tr>
                                              <th>{t("Sales Area")} :</th>
                                             <td>
  {complaintDetails
    ?.companyDetails
    ?.selectedSaleAreas?.[0]
    ?.sales_area_name
  ||
  edit?.complaintDetails
    ?.companyDetails
    ?.selectedSaleAreas?.[0]
    ?.sales_area_name
  ||
  "-"}
</td>

                                            </tr>
                                            <tr>
                                              <th>{t("Outlet Unique ID")} :</th>
                                           <td>
  {complaintDetails?.companyDetails?.outletDetail?.outlet_unique_id
  ||
  edit?.complaintDetails
    ?.companyDetails
    ?.outletDetail
    ?.outlet_unique_id
  ||
  "-"}
</td>

                                            </tr>

                                            <tr>
                                              <th>{t("Outlet Name")} :</th>
                                              {/* <td>₹ {accountBalance?.balance || "0.00"}</td> */}

                                            <td>
  {complaintDetails?.companyDetails?.outletDetail?.outlet_name
  ||
  edit?.complaintDetails
    ?.companyDetails
    ?.outletDetail
    ?.outlet_name
  ||
  "-"}
</td>

                                            </tr>
                                            <tr>
                                              <th>{t("Customer Code")} :</th>
                                              {/* <td>
                                                                      {allAccountByBankId?.find(
                                                                        (item) =>
                                                                          item?.value ===
                                                                          props.values?.account_id?.value
                                                                      )?.branch || "-"}
                                                                    </td> */}
                                              {/* 
                                            {complaintDetails?.outlet?.[0]
                                              ?.customer_code ||
                                              complaintDetails.outlet_customer_code ||
                                              "-"} */}
                                            <td>
  {complaintDetails
    ?.companyDetails
    ?.outletDetail
    ?.customer_code
  ||
  edit?.complaintDetails
    ?.companyDetails
    ?.outletDetail
    ?.customer_code
  ||
  "-"}
</td>

                                            </tr>
                                            <tr>
                                              <th>{t("Catergory")} :</th>
                                              {/* <td>
                                                                      {allAccountByBankId?.find(
                                                                        (item) =>
                                                                          item?.value ===
                                                                          props.values?.account_id?.value
                                                                      )?.branch || "-"}
                                                                    </td> */}

                                           <td>
  {complaintDetails
    ?.companyDetails
    ?.outletDetail
    ?.outlet_category
  ||
  edit?.complaintDetails
    ?.companyDetails
    ?.outletDetail
    ?.outlet_category
  ||
  "-"}
</td>

                                            </tr>
                                            <tr>
                                              <th>
                                                {t(
                                                  "Already  Punched Amount "
                                                )}{" "}
                                                :
                                              </th>
                                             <td>
  {formatAmountINR(
    complaintDetails?.complaint_punched_amount ??
      edit?.total_punched_amount ??
      0
  )}
</td>

                                              {/* {complaintData[0]?.fund_amount} */}
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="p-20 shadow rounded h-100">
                                      <strong className="text-secondary">
                                        {t("User Details")}
                                      </strong>

                                      <div className="mt-2">
                                        <table className="table-sm table">
                                          <tbody>
                                            <tr>
                                              <th>{t("User Name")} :</th>
                                              <td>
                                                {/* {userDetails?.request_by_name ||
                                                "-"} */}
                                                {edit?.user_name || "-"}
                                              </td>
                                            </tr>

                                            <tr>
                                              <th>
                                                {t("Transferred Amount")} :
                                              </th>
                                              <td>
                                                {/* {userDetails?.wallet_balance ||
                                                "0.00"} */}
                                                {edit?.total_transfer_amount != null
                                                  ? formatAmountINR(edit.total_transfer_amount)
                                                  : "-"}
                                              </td>
                                            </tr>

                                            {/* <tr>
                                            <th>{t("Closing Balance")} :</th>
                                            <td>
                                                                      ₹
                                                                      {userDetails[0].closing_balance || "0.00"}
                                                                    </td>
                                          </tr> */}
                                            <tr>
                                              <th>{t("Punched Amount")} :</th>
                                              <td>
                                                {formatAmountINR(edit?.total_expense_transfer_amount ?? 0)}
                                              </td>

                                            </tr>
                                            <tr>
                                              <th>
                                                {t("Remaining Balance")} :
                                              </th>
                                              <td>
                                                {/* {userDetails?.wallet_balance -
                                                userDetails?.expense_transfer_amount ||
                                                "0.00"} */}
                                                {edit?.remaining_amount != null
                                                  ? formatAmountINR(edit.remaining_amount)
                                                  : "-"}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </Col>
                                </div>
                              </Row>

                              {props.values.expense_punch_for == 2 && (
                                <div className=" mb-4 ">
                                  Manager Name:{" "}
                                  <span className="fw-bold">
                                    {props.values?.area_manager_id?.name ??
                                      "--"}
                                  </span>
                                  <br />
                                  {props.values?.supervisor_id?.name && (
                                    <span>
                                      {" "}
                                      Supervisor Name:{" "}
                                      <span className="fw-bold">
                                        {" "}
                                        {props.values?.supervisor_id?.name ??
                                          "--"}
                                      </span>
                                    </span>
                                  )}
                                  <br />
                                  {props.values?.end_users_id?.name && (
                                    <span>
                                      Enduser Name:{" "}
                                      <span className="fw-bold">
                                        {" "}
                                        {props.values?.end_users_id?.name ??
                                          "--"}
                                      </span>
                                    </span>
                                  )}
                                </div>
                              )}

                              {props.values.items.length > 0 && (
                                <div style={{ overflowX: "auto", width: "100%" }}>
                                <Table
                                  striped
                                  hover
                                  className="text-body bg-new Roles my-3"
                                  style={{ minWidth: "1500px", whiteSpace: "nowrap" }}
                                >
                                  <thead>
                                    <tr>
                                      <th style={{ minWidth: "150px" }}>Item Name</th>
                                      <th style={{ minWidth: "120px" }}>Transfer Date</th>
                                      <th style={{ minWidth: "110px" }}>Punch Quantity</th>
                                      <th style={{ minWidth: "110px" }}>Punch Amount</th>
                                      <th style={{ minWidth: "120px" }}>Approve Quantity</th>
                                      <th style={{ minWidth: "120px" }}>Approve Amount</th>
                                      <th style={{ minWidth: "130px" }}>Remaining Quantity </th>
                                      <th style={{ minWidth: "130px" }}>Remaining Amount</th>
                                      <th style={{ minWidth: "100px" }}>Total Price </th>
                                      {/* Approving 0 rejects the item. It used to do
                                          so silently, so the reason is collected here
                                          and shown to the person who punched. */}
                                      <th style={{ minWidth: "180px" }}>
                                        Reason (if not approving)
                                      </th>
                                      {/* <th>payment Mode</th>
                                      <th>Transaction Id </th> */}
                                      <th style={{ minWidth: "110px" }}>Stock Month</th>
                                      <th style={{ minWidth: "160px" }}>Punch Date &amp; Time</th>
                                      <th style={{ minWidth: "220px" }}>{t("Remarks")}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {props.values.items.map((itm, index) => (
                                      <tr key={index}>
                                        <td width={"150px"}>
                                          <Select
                                            className="text-start"
                                            menuPortalTarget={document.body}
                                            name={`items.${index}.item_name`}
                                            value={{
                                              label: itm?.item_name,
                                              image: itm?.item_images,
                                            }}
                                            isDisabled
                                            formatOptionLabel={
                                              itemFormatOptionLabel
                                            }
                                          />
                                          <ErrorMessage
                                            name={`items.${index}.item_name`}
                                            component="span"
                                            className="text-danger"
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            placeholder="-"
                                            value={itm?.transfer_date || ""}
                                            disabled
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            name={`items.${index}.punched_qty`}
                                            placeholder="0"
                                            value={itm.punched_qty}
                                            disabled
                                            onChange={props.handleChange}
                                          />
                                        </td>

                                        <td>
                                          <Form.Control
                                            name={`items.${index}.total_Amount`}
                                            placeholder="0"
                                            value={itm.total_Amount}
                                            disabled
                                            onChange={props.handleChange}
                                          />
                                        </td>



                                        <td>
                                          <MyInput
                                            name={`items.${index}.approved_qty`}
                                            type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                                            step="0.01"
                                            formikProps={props}
                                            // onChange={(e) => {
                                            //   const qty = Number(e.target.value || 0);
                                            //   const maxQty = Number(itm.punched_qty || 0);
                                            //   const price = Number(itm.item_price || 0);

                                            //   const finalQty = qty > maxQty ? maxQty : qty;

                                            //   const reemainingQty = maxQty - finalQty;
                                            //   const remainingAmt = itm.total_Amount - finalQty * price;

                                            //   props.setFieldValue(`items.${index}.approved_qty`, finalQty);
                                            //   props.setFieldValue(`items.${index}.total_price`, finalQty * price);
                                            //   props.setFieldValue(`items.${index}.remaining_qty`, reemainingQty);
                                            //   props.setFieldValue(`items.${index}.remaining_amount`, remainingAmt);
                                            // }}

                                             onChange={(e) => {
    const value = e.target.value;

    // ✅ allow only 3 decimal places
    if (!/^\d*\.?\d{0,3}$/.test(value)) return;

    const qty = Number(value || 0);
    const maxQty = Number(itm.punched_qty || 0);
    const price = Number(itm.item_price || 0);
    const totalAmount = Number(itm.total_Amount || 0);

    // Cap only if user exceeds max; otherwise preserve their raw string so
    // an in-progress decimal like "1." doesn't get collapsed to 1 (which
    // would strip the trailing dot and block decimal entry).
    const exceedsMax = qty > maxQty;
    const finalQty = exceedsMax ? maxQty : qty;

    // Qty stays exact (up to 3 dp); money amounts rounded to 2 dp so the field
    // shows clean rupees (no 18.9000000004 float artifacts) and remaining never
    // shows a "-0.00".
    const remainingQty = maxQty - finalQty;
    const approvedAmt = Number((finalQty * price).toFixed(2));
    const remainingAmt = Number((totalAmount - approvedAmt).toFixed(2));

    props.setFieldValue(
      `items.${index}.approved_qty`,
      exceedsMax ? finalQty : value,
    );
    props.setFieldValue(`items.${index}.total_price`, approvedAmt);
    props.setFieldValue(`items.${index}.remaining_qty`, remainingQty);
    props.setFieldValue(`items.${index}.remaining_amount`, remainingAmt);
  }}
                                          />

                                        </td>




                                        <td>
                                          <MyInput
                                            type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                                            step="0.01"
                                            name={`items.${index}.total_price`}
                                            value={props.values.items[index].total_price}
                                           onChange={(e) => {
  const rawAmount = e.target.value;

  // ⭐ allow only 2 decimal
  if (!/^\d*\.?\d{0,2}$/.test(rawAmount)) return;

  let amount = Number(rawAmount || 0);

  const price = Number(itm.item_price || 0);
  const maxQty = Number(itm.punched_qty || 0);
  const totalAmount = Number(itm.total_Amount || 0);

  // ⭐ amount should not exceed totalAmount
  const exceedsMax = amount > totalAmount;
  if (exceedsMax) amount = totalAmount;

  let calculatedQty = price ? amount / price : 0;

  // ⭐ qty should not exceed maxQty (what was actually punched)
  if (calculatedQty > maxQty) calculatedQty = maxQty;

  // Qty stays exact (up to 3 dp); money amounts rounded to 2 dp for a clean
  // display (no float artifacts / "-0.00").
  const finalQty = calculatedQty;
  const finalAmount = amount;
  const remainingQty = maxQty - finalQty;
  const remainingAmt = Number((totalAmount - finalAmount).toFixed(2));

  props.setFieldValue(`items.${index}.approved_qty`, finalQty);
  // Preserve user's raw string so "1." doesn't collapse to 1 mid-type.
  // Only override with capped number if they exceeded the max.
  props.setFieldValue(
    `items.${index}.total_price`,
    exceedsMax ? finalAmount : rawAmount,
  );
  props.setFieldValue(`items.${index}.remaining_qty`, remainingQty);
  props.setFieldValue(`items.${index}.remaining_amount`, remainingAmt);
}}
                                          />



                                        </td>


                                        <td>
                                          <MyInput
                                            name={`items.${index}.remaining_qty`}
                                            value={props.values.items[index].remaining_qty}
                                            disabled
                                          />
                                        </td>

                                        <td>
                                          <MyInput
                                            name={`items.${index}.remaining_amount`}
                                            value={Number(props.values.items[index].remaining_amount || 0).toFixed(2)}
                                            disabled
                                          />
                                        </td>

                                        <td>
                                          {formatAmountINR(itm?.total_price || 0)}
                                        </td>

                                        {/* Only live when the row is being rejected
                                            (approve quantity 0). The backend refuses a
                                            zero approval without a reason. */}
                                        <td>
                                          <Form.Control
                                            name={`items.${index}.reject_remark`}
                                            placeholder={
                                              Number(
                                                props.values.items[index]
                                                  ?.approved_qty || 0,
                                              ) === 0
                                                ? "Why is this not approved?"
                                                : "—"
                                            }
                                            value={
                                              props.values.items[index]
                                                ?.reject_remark || ""
                                            }
                                            disabled={
                                              Number(
                                                props.values.items[index]
                                                  ?.approved_qty || 0,
                                              ) !== 0
                                            }
                                            onChange={props.handleChange}
                                          />
                                        </td>

                                        {/* <td>
                                          <Form.Group>
                                            <Select
                                              menuPortalTarget={document.body}
                                              placeholder="Payment Mode"
                                              name={`items.${index}.payment_mode`}
                                              options={[
                                                { label: "UPI", value: "upi" },
                                                {
                                                  label: "Net Banking",
                                                  value: "net_banking",
                                                },
                                              ]}
                                              onChange={(e) => {
                                                props.setFieldValue(
                                                  `items.${index}.payment_mode`,
                                                  e?.value
                                                );
                                              }}
                                            />
                                          </Form.Group>
                                        </td>

                                        <td>
                                          <Form.Control
                                            name={`items.${index}.transaction_id`}
                                            onChange={props.handleChange}
                                          />
                                          <ErrorMessage
                                            name={`items.${index}.transaction_id`}
                                            component="span"
                                            className="text-danger"
                                          />
                                        </td> */}

                                        <td>{itm?.stock_month || "-"}</td>
                                        <td>{itm?.punch_at}</td>
                                        <td>
                                          <PunchItemRemarksCell remarks={punchRemarks} itemName={itm?.item_name} canEdit />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                                </div>
                              )}
                              <div className="mt-2 text-end fs-6 fw-bold">
                                Total Amount{" "}
                                {formatAmountINR(
                                  props.values.items.reduce(
                                    (total, item) =>
                                      total + Number(item.total_Amount || 0),
                                    0
                                  )
                                )}
                              </div>
                            </div>
                          )}
                        </FieldArray>
                        <FieldArray name={`payment_images`}>
                          {({
                            push: pushPaymentImage,
                            remove: removePaymentImage,
                          }) => (
                            <PaymentImages
                              props={props}
                              id={id}
                              pushPaymentImage={pushPaymentImage}
                              removePaymentImage={removePaymentImage}
                              fromcreate={true}
                              paymentMethodOptions={allPaymentMethod}
                            />
                          )}
                        </FieldArray>
                        <Form.Group as={Col} md={12}>
                          <div className="mt-2 text-center">
                            <button
                              type={`button`}
                              onClick={() => setShowAlert(true)}
                              disabled={props?.isSubmitting}
                              className="shadow border-0 purple-combo cursor-pointer px-4 py-1"
                            >
                              {props?.isSubmitting ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    variant="primary"
                                    size="sm"
                                  />
                                  PLEASE WAIT...
                                </>
                              ) : (
                                <>Submit</>
                              )}
                            </button>
                            {props.values.items.reduce(
                              (total, item) =>
                                total + Number(item.total_price || 0),
                              0
                            ) > Number(edit?.remaining_amount || 0) && (
                                <span className="text-danger">
                                  * Wallet Balance is Low
                                </span>
                              )}
                            <ConfirmAlert
                              size={"sm"}
                              defaultIcon={<BsQuestionLg />}
                              deleteFunction={props.handleSubmit}
                              formikProps={props}
                              hide={setShowAlert}
                              show={showAlert}
                              title={"Confirm Punch"}
                              description={
                                "Are you sure you want to punch this!!"
                              }
                            />
                          </div>
                        </Form.Group>
                      </>
                    )}
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </CardComponent>
      </Col>
    </>
  );
};

export default ApproveExpenseRequest;
